export default "__VITE_ASSET__0b064ae1__"